module.exports = __webpack_public_path__ + "img/man-end.e752ce0e.png";